export default "__VITE_ASSET__e619388b__"